export enum TrainButtonState {
  INACTIVE = 'INACTIVE',
  ACTIVE = 'ACTIVE',
  TRAINED = 'TRAINED',
}

export const getButtonState = (canBeTrained: boolean, isTrained: boolean): TrainButtonState => {
  if (isTrained) {
    return TrainButtonState.TRAINED
  } else if (canBeTrained) {
    return TrainButtonState.ACTIVE
  } else {
    return TrainButtonState.INACTIVE
  }
}

export const trainButtonBackgroundMap: Record<TrainButtonState, string> = {
  [TrainButtonState.INACTIVE]: '#C7CAD6',
  [TrainButtonState.ACTIVE]: 'linear-gradient(285.2deg, #5A98F7 -35.9%, #1658F3 61.17%)',
  [TrainButtonState.TRAINED]: 'linear-gradient(285.2deg, #34D399 -35.9%, #059669 61.17%)',
}
